/**
 * Scroll handler to show scrollbar only when scrolling
 * This adds/removes classes to the html element based on scroll activity
 */

// Set up a timeout to track when scrolling stops
let scrollTimeout;

// Function to handle scroll events
const handleScroll = () => {
  // Add the 'scrolling' class to the html element
  document.documentElement.classList.add('scrolling');
  document.documentElement.classList.remove('not-scrolling');
  
  // Clear any existing timeout
  clearTimeout(scrollTimeout);
  
  // Set a timeout to remove the 'scrolling' class after scrolling stops
  scrollTimeout = setTimeout(() => {
    document.documentElement.classList.remove('scrolling');
    document.documentElement.classList.add('not-scrolling');
  }, 1000); // Hide scrollbar 1 second after scrolling stops
};

// Initialize the scroll handler
export const initScrollHandler = () => {
  // Set initial state
  document.documentElement.classList.add('not-scrolling');
  
  // Add scroll event listener
  window.addEventListener('scroll', handleScroll, { passive: true });
  
  // Clean up function for when component unmounts
  return () => {
    window.removeEventListener('scroll', handleScroll);
    clearTimeout(scrollTimeout);
  };
};

export default initScrollHandler;
